import React from 'react';
import { KMRS_THIRD_PARTY } from 'common/constants';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/**
 * 동의 6(K-MRS판): 개인정보 제3자 제공 동의 — 서울특별시약사회·서울대학교 (K-MRS 경로 전용, CONSENT_VERSION_KMRS).
 * 제공받는 자/항목/목적/보유기간은 [외부] 확정 전 자리값이라 common/constants의 KMRS_THIRD_PARTY 한 곳에서 가져온다.
 */
const ConsentDetail6Kmrs: React.FC = () => (
  <DetailContainer>
    {/* K-MRS 전용 시트 — 제목은 항상 K-MRS 스타일($kmrs). 긴 제공받는 자 이름이 닫기 버튼을 덮지 않게 한다(D3). */}
    <DetailTitle $kmrs>개인정보 제3자 제공 동의 ({KMRS_THIRD_PARTY.recipient})</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>제공받는 자</DetailLabel>
          <DetailValue><strong>{KMRS_THIRD_PARTY.recipient}</strong></DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>이용 목적</DetailLabel>
          <DetailValue>{KMRS_THIRD_PARTY.purpose}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>제공하는 항목</DetailLabel>
          <DetailValue>{KMRS_THIRD_PARTY.items}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>보유·이용 기간</DetailLabel>
          <DetailValue>
            <strong>{KMRS_THIRD_PARTY.retention}</strong>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 본 개인정보의 제3자 제공에 동의를 거부할 권리가 있습니다.
            <p className="note">
              ※ 단, 본 동의 없이는 약사 상담을 위한 복용 약 정보 연동 서비스를 제공할 수 없습니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail6Kmrs;
